import { useEffect } from 'react'

import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { unsubscribeGhostUser } from 'services/apis/ghostUser'

import useParticipants, {
    getIdentity,
} from '../useParticipants/useParticipants'

const isGhost = (identity = '') => getIdentity(identity).isGhost

const useGhostUser = () => {
    const { room } = useVideoContext()
    const localParticipant = room.localParticipant
    const localParticipantIdentity = room.localParticipant.identity
    const { participants, ghost } = useParticipants()

    useEffect(() => {
        let ghostUser = null

        if (isGhost(localParticipantIdentity)) {
            ghostUser = localParticipant
        } else {
            ghostUser = participants.find(p => isGhost(p.identity))
        }

        ghostUser &&
            unsubscribeGhostUser(
                ghostUser.identity,
                room.sid,
                room.localParticipant.sid
            )
    }, [])

    useEffect(() => {
        if (!ghost) return
        unsubscribeGhostUser(ghost, room.sid, room.localParticipant.sid)
    }, [ghost])
}

export default useGhostUser
